export const DATE_RANGE_PRESETS = {
  ALL_DATES: 'allDates',
  NO_DUE_DATE: 'noDueDate',
  THIS_WEEK: 'thisWeek',
  THIS_AND_NEXT_WEEK: 'thisAndNextWeek',
  NEXT_WEEK: 'nextWeek',
  NEXT_TWO_WEEKS: 'nextTwoWeeks',
  NEXT_30_DAYS: 'next30Days',
  THIS_MONTH: 'thisMonth',
  NEXT_MONTH: 'nextMonth',
  LAST_MONTH: 'lastMonth',
  THIS_QUARTER: 'thisQuarter',
  Q1: 'q1',
  Q2: 'q2',
  Q3: 'q3',
  Q4: 'q4',
  CUSTOM: 'custom',
}

export const DEFAULT_DATE_RANGE_PRESET = DATE_RANGE_PRESETS.THIS_MONTH
export const DEFAULT_INCLUDE_NO_DUE_DATE = true
export const DEFAULT_INCLUDE_DUE_BEFORE_RANGE = true

export const DATE_RANGE_PRESET_OPTIONS = [
  { label: 'All dates', value: DATE_RANGE_PRESETS.ALL_DATES },
  { label: 'This week', value: DATE_RANGE_PRESETS.THIS_WEEK },
  {
    label: 'This and next week',
    value: DATE_RANGE_PRESETS.THIS_AND_NEXT_WEEK,
  },
  { label: 'Next week', value: DATE_RANGE_PRESETS.NEXT_WEEK },
  { label: 'Next two weeks', value: DATE_RANGE_PRESETS.NEXT_TWO_WEEKS },
  { label: 'Next 30 days', value: DATE_RANGE_PRESETS.NEXT_30_DAYS },
  { label: 'This month', value: DATE_RANGE_PRESETS.THIS_MONTH },
  { label: 'Next month', value: DATE_RANGE_PRESETS.NEXT_MONTH },
  { label: 'Last month', value: DATE_RANGE_PRESETS.LAST_MONTH },
  { label: 'This quarter', value: DATE_RANGE_PRESETS.THIS_QUARTER },
  { label: 'Q1', value: DATE_RANGE_PRESETS.Q1 },
  { label: 'Q2', value: DATE_RANGE_PRESETS.Q2 },
  { label: 'Q3', value: DATE_RANGE_PRESETS.Q3 },
  { label: 'Q4', value: DATE_RANGE_PRESETS.Q4 },
  { label: 'No due date', value: DATE_RANGE_PRESETS.NO_DUE_DATE },
  { label: 'Custom range', value: DATE_RANGE_PRESETS.CUSTOM },
]

export const POPOVER_WIDTH = 320
export const PRESET_OPTION_HEIGHT = 36
export const PRESET_OPTIONS_LIST_VERTICAL_PADDING = 16
export const PRESET_OPTIONS_SCROLL_AREA_HEIGHT = 320

export const getDatePickerSlotProps = (helperText) => ({
  clearButton: {
    disableRipple: true,
    sx: {
      opacity: '1 !important',
    },
  },
  clearIcon: {
    sx: {
      fontSize: 16,
    },
  },
  field: {
    clearable: true,
  },
  openPickerButton: {
    disableRipple: true,
  },
  openPickerIcon: {
    sx: {
      fontSize: 20,
    },
  },
  textField: {
    size: 'small',
    fullWidth: true,
    helperText,
    InputLabelProps: {
      sx: { fontSize: 14 },
    },
    InputProps: {
      sx: {
        height: 36,
        '& .MuiPickersInputBase-sectionContent': {
          fontSize: 14,
        },
      },
    },
  },
})
